import { UsersAPI } from "api/users";
import { setTabToken } from "common/MetaActions";
import { RootState } from "store";
import { StateCreator } from "zustand";

export interface GenerateOnetimeLoginSlice {
  hasSent: boolean;
  invalid: boolean;

  onetimeLoginSent: (hasSent: boolean) => void;
  generateOnetimeLogin: (email: string) => void;
  setIsOnetimeLoginValid: (isValid: boolean) => void;
  onetimeLogin: (onetimeLoginGuid: string) => void;
}

export const createGenerateOnetimeLoginSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  GenerateOnetimeLoginSlice
> = (set, get) => ({
  hasSent: false,
  invalid: false,

  onetimeLoginSent: (hasSent) =>
    set(
      ({ generateOnetimeLogin }) => ({
        generateOnetimeLogin: {
          ...generateOnetimeLogin,
          hasSent
        }
      }),
      false,
      "generateOnetimeLogin/ONETIME_LOGIN_SENT"
    ),

  setIsOnetimeLoginValid: (isValid) =>
    set(
      ({ generateOnetimeLogin }) => ({
        generateOnetimeLogin: {
          ...generateOnetimeLogin,
          invalid: isValid
        }
      }),
      false,
      "generateOnetimeLogin/SET_IS_ONETIME_LOGIN_VALID"
    ),

  generateOnetimeLogin: async (email) => {
    set({}, false, "generateOnetimeLogin/GENERATE_ONETIME_LOGIN");
    try {
      get().generateOnetimeLogin.onetimeLoginSent(false);
      await UsersAPI.generateOnetimeLogin(email);
      get().generateOnetimeLogin.onetimeLoginSent(true);
    } catch (error) {
      get().error.appendErrorNotification(
        "Skapandet av engångslänk för inloggning misslyckades.",
        error
      );
    }
  },

  onetimeLogin: async (onetimeLoginGuid) => {
    set({}, false, "generateOnetimeLogin/ONETIME_LOGIN");
    try {
      get().generateOnetimeLogin.setIsOnetimeLoginValid(false);
      const response = await UsersAPI.onetimeLogin(onetimeLoginGuid);
      setTabToken(response.token);
      get().user.loginUser(response.token);
      get().generateOnetimeLogin.setIsOnetimeLoginValid(true);
    } catch (error) {
      get().generateOnetimeLogin.setIsOnetimeLoginValid(false);
      get().error.appendErrorNotification("Inloggning med engångslänk misslyckades.", error);
    }
  }
});
